import type { FaireProductEntity } from "../../entity_types/product";

export const p_5pwf9umu3e: FaireProductEntity = {
  token: "p_5pwf9umu3e",
  type: "product",
  name: "Feral Grip Socks",
  brandToken: "b_1fc44661",
  brandName: "Gumball Poodle",
  imageUrl: "https://cdn.faire.com/fastly/edb005ead369fbe5bd896e82e54c1a6132762e4df82b7357b3ae655183b8a6cb.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/2a57f7c653726be0cd3eeca42ddf22f616c259e25ed092d3b4c6601478dff118.jpeg",
    "https://cdn.faire.com/fastly/42686452fcd3676f98ab93cef7c344a3a8f124c921d44212965ce97f2a5b29f4.jpeg",
    "https://cdn.faire.com/fastly/3a28b577374e3fc9fd4721c050ab4332c3a2654d0225f15e19721eee2eb13ca7.jpeg",
    "https://cdn.faire.com/fastly/8d8998667e7af8799bae2dc25cbfd77d688fde137cc5e1658d4fafaae5f124be.jpeg",
    "https://cdn.faire.com/fastly/03b0fe0eb944dc0b747524631052a19a9c8ea1e546b06b39aee41ec5d300ffbb.jpeg",
    "https://cdn.faire.com/fastly/b1b7b7459d7e3f5dce6635d1268209d959ef102d869798e20faca7a1b45e8acf.jpeg",
    "https://cdn.faire.com/fastly/9f80860adda1cba04f9e4e49d9922f2f57190332e3bc276bbfe98abfb2b55a55.jpeg",
    "https://cdn.faire.com/fastly/8c51b9568edbc2534229a96eddb484568a610b87ae2f250b04776b1f5ad85e08.jpeg"
  ],
  priceDollars: 9.6,
  description: "When stopping is technically possible but spiritually offensive, you've reached feral status, and you may need to get a grip (socks). 👹\n\nFinally! Grip socks that do a better job and look good doing it. 🤩\n\n• Woven-in premium grip yarn that holds up use after use. No glued-on dots.\n• Knit into the heel and toe, not just the sole, for better stability.\n• Built for Pilates, barre, yoga, and every stretch in between.\n• Bold, funny, and unreasonably well made in the USA!\n\n#pilatessocks #gripsocks #grippysocks #barresocks #yogasocks #grippy #lagreesocks #pilates #barre #lagree #yoga #grip\n\nGumball Poodle is GPSR compliant! We will automatically be stickering all orders into the EU or Northern Ireland for GPSR compliance.\n\nIf you are in the UK but sell into the EU, we can provide you with the necessary stickers to put on products - be sure to tell us you need these when you place your order.",
  tags: [],
  msrpDollars: 20,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-12T05:33:21.680Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
